import { supabase } from "../../supabaseClient";

interface CompletionParams {
  prompt: string;
  model?: "gemini-pro" | "gemini-1.5-pro-latest";
}

// https://cotr-violetTrout.web.val.run/
export const getGeminiCompletion = async ({
  prompt,
  model = "gemini-pro",
}: CompletionParams): Promise<string> => {
  try {
    const response = await supabase.functions.invoke("get-gemini-completion", {
      body: { prompt, model },
    });

    if (response.error) {
      throw new Error("Error generating AI completion");
    }

    const completion = await response.data;
    return completion;
  } catch (error) {
    console.error("Error generating AI completion:", error);
    throw error;
  }
};

export const getGeminiEmbedding = async (content: string) => {
  try {
    const response = await supabase.functions.invoke("get-gemini-embedding", {
      body: { content },
    });

    if (response.error) {
      throw new Error("Error generating AI completion");
    }

    const output = await response.data;

    return output;
  } catch (error) {
    console.error("Error generating AI embedding:", error);
    throw error;
  }
};

export const getGeminiTokenCount = async (content: string) => {
  try {
    const response = await supabase.functions.invoke("get-gemini-token-count", {
      body: { content },
    });

    if (response.error) {
      throw new Error("Error generating AI completion");
    }

    const output = await response.data;

    console.log("Count", output);

    return output;
  } catch (error) {
    console.error("Error generating token count:", error);
    throw error;
  }
};

export const getGeminiJson = async (prompt: string): Promise<string> => {
  try {
    const response = await supabase.functions.invoke("get-gemini-json", {
      body: { prompt },
    });

    if (response.error) {
      throw new Error("Error generating AI JSON");
    }

    const json = await response.data;

    console.log("Json", json);

    return json;
  } catch (error) {
    console.error("Error generating JSON:", error);
    throw error;
  }
};
